module.exports = __webpack_public_path__ + "static/mobile-air-1cfb0d376b639b7f8001a93276373211.png";